module.exports = __webpack_public_path__ + "img/klang.b14c124e.png";